import { useEffect, useState } from 'react';

export type SubdomainType = 'admin' | 'parish' | 'client' | null;

export const getSubdomainFromHostname = (hostname: string): SubdomainType => {
  if (hostname.includes('localhost')) {
    const parts = hostname.split('.');
    if (parts.length >= 2) {
      const subdomainPart = parts[0];
      if (subdomainPart === 'admin') return 'admin';
      if (subdomainPart === 'parish') return 'parish';
      if (subdomainPart === 'client') return 'client';
    }
  } else {
    const parts = hostname.split('.');
    if (parts.length >= 3) {
      const subdomainPart = parts[0];
      if (subdomainPart === 'admin') return 'admin';
      if (subdomainPart === 'parish') return 'parish';
      if (subdomainPart === 'client') return 'client';
    }
  }
  return null;
};

/**
 * Resolve o subdomínio atual. O valor inicial é síncrono (hostname) para o primeiro paint
 * do React não disparar árvores de rotas erradas antes do primeiro useEffect — ex.: em
 * `admin.localhost:3001/events`, `null` fazia matching de `:eventSlug` com "events" e
 * gerava GET /api/public/events (404).
 */
export const useSubdomain = (): SubdomainType => {
  const [subdomain, setSubdomain] = useState<SubdomainType>(() =>
    typeof window !== 'undefined' ? getSubdomainFromHostname(window.location.hostname) : null
  );

  useEffect(() => {
    setSubdomain(getSubdomainFromHostname(window.location.hostname));
  }, []);

  return subdomain;
};
